import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var paginationComponentName = 'QuantumPagination';
export function getPaginationUtilityClass(slot) {
    return generateUtilityClass(paginationComponentName, slot);
}
export var paginationClasses = generateUtilityClasses(paginationComponentName, [
    'root',
    'pageSelect',
    'pageLabelText',
    'previousPageButton',
    'nextPageButton',
]);
